import { render, staticRenderFns } from "./ProductTrendChart.vue?vue&type=template&id=4fec287c"
import script from "./ProductTrendChart.vue?vue&type=script&lang=js"
export * from "./ProductTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports